import { useEffect, useState } from 'react';
import { appApi } from '../utils/api';
import type { AppInfo } from '../types/api';

/**
 * 拉取当前账号名下的应用列表，用于报表 / 支付记录的 app_id 过滤。
 * 无支付权限的账号会拿到空列表，此时仅展示「全部应用」。
 */
export function useAppOptions(): { apps: AppInfo[]; loading: boolean } {
  const [apps, setApps] = useState<AppInfo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const response = await appApi.getList(1, 100);
        if (!cancelled && response.code === 1 && response.data) {
          setApps(Array.isArray(response.data.data) ? response.data.data : []);
        }
      } catch (error) {
        console.error('Failed to fetch applications:', error);
      }
      if (!cancelled) setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { apps, loading };
}
